/// <amd-module name="typeahead/client/FlightSearchResultsPageHandler" />

import {ClientHandlerRegistry, IClientHandler} from "typeahead/client/ClientHandlerRegistry";
import {GeolocationViewController} from "typeahead/core/geolocation/GeolocationViewController";

export class FlightSearchResultsPageHandler implements IClientHandler {
    private static readonly rfrrIdPrefix: string = "FLT.SR|UpdateSearch";
    private static readonly APPLICABLE_CLIENT_ID = "Flights.Search";

    public isApplicable(clientId: string): boolean {
        return FlightSearchResultsPageHandler.APPLICABLE_CLIENT_ID === clientId;
}

    public subscribeFormSubmitEvent(): void {
        const that = this;
        $("body").on("click", "#flight-wizard-search-button", () => {
            const isFormValid = (): boolean => {
                const validationElement = $("#validation-alert");
                return !validationElement.length;
            };
            ClientHandlerRegistry.publishSubmitClickedMessage(FlightSearchResultsPageHandler.rfrrIdPrefix);
            if (isFormValid()) {
                ClientHandlerRegistry.publishFormSubmittedMessage(true);
            }
        });
    }

    public subscribeFormLoadedEvent(): void {
        // TODO
    }

    public getTab(): string {
        return undefined;
    }

    public getGeolocationViewController(): GeolocationViewController {
        return undefined;
    }
}
